import React from "react";

const NumberFormat = ({children}) => {
    const formatNumber = (num) => {
        const parsed = parseFloat(num);
        if (isNaN(parsed)) return '';
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            maximumFractionDigits: 2,
        }).format(parsed);
    };

    return <>{formatNumber(children)}</>
}

export default NumberFormat;
